import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@devhop/ui";
import type { QiStockShortfallDTO } from "../api/catalog-types";

type IssueQuotationStockPrecheckDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  loading: boolean;
  documentNumber: string;
  checkResult: { ok: boolean; shortfalls: QiStockShortfallDTO[] } | null;
  onConfirmIssue: () => void;
};

export function IssueQuotationStockPrecheckDialog({
  open,
  onOpenChange,
  loading,
  documentNumber,
  checkResult,
  onConfirmIssue,
}: IssueQuotationStockPrecheckDialogProps) {
  const blocked = checkResult != null && !checkResult.ok;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle>ກວດສຕັອກກ່ອນອອກໃບສະເໜີລາຄາ</DialogTitle>
        </DialogHeader>

        {loading ? (
          <p className="text-muted-foreground text-sm">ກຳລັງກວດ available…</p>
        ) : blocked ? (
          <>
            <p className="text-destructive text-sm">
              ສຕັອກບໍ່ພໍສຳລັບອອກເອກະສານ #{documentNumber} — ແກ້ qty ຫຼື ເພີ່ມສຕັອກກ່ອນ
            </p>
            <div className="max-h-60 overflow-y-auto rounded-md border">
              <table className="w-full text-sm">
                <thead>
                  <tr className="border-b bg-muted/40 text-left text-muted-foreground">
                    <th className="px-3 py-2 font-medium">SKU</th>
                    <th className="px-3 py-2 font-medium text-right">ຕ້ອງການ</th>
                    <th className="px-3 py-2 font-medium text-right">ພ້ອມ</th>
                    <th className="px-3 py-2 font-medium text-right">ຂາດ</th>
                  </tr>
                </thead>
                <tbody>
                  {checkResult?.shortfalls.map((row) => (
                    <tr key={row.productId} className="border-b last:border-0">
                      <td className="px-3 py-2">
                        {row.productCode ?? row.productName ?? row.productId}
                      </td>
                      <td className="px-3 py-2 text-right tabular-nums">
                        {row.needed.toLocaleString()}
                      </td>
                      <td className="px-3 py-2 text-right tabular-nums">
                        {row.available.toLocaleString()}
                      </td>
                      <td className="px-3 py-2 text-right font-medium text-destructive tabular-nums">
                        {row.shortfall.toLocaleString()}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        ) : checkResult?.ok ? (
          <p className="text-sm">
            ສຕັອກພໍສຳລັບອອກເອກະສານ #{documentNumber} — ຢືນຢັນເພື່ອອອກໃບ ແລະ
            ຈອງສຕັອກທີ່ສາຂາ HQ ທີ່ເລືອກ
          </p>
        ) : null}

        <DialogFooter>
          <Button
            type="button"
            variant="outline"
            onClick={() => onOpenChange(false)}
          >
            {blocked ? "ປິດ" : "ຍົກເລີກ"}
          </Button>
          {!loading && checkResult?.ok ? (
            <Button type="button" onClick={onConfirmIssue}>
              ອອກເອກະສານ
            </Button>
          ) : null}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
